module.exports = __webpack_public_path__ + "img/nav-07.2dc8f429.jpg";